__turbopack_context__.v({
  "className": "cormorant_garamond_f6930952-module__OAKPWa__className",
});
